import { Navigate, useRoutes } from 'react-router-dom';

import { APP_PATH } from 'src/Tools/Constants';
import { getNext, getToken } from '../Api/Tools/Api';
import Auth from "./Auth/Auth";
import Blank from "./Blank/Blank";
import LLMInteractionCategories from "./LLMInteractionCategories/LLMInteractionCategories";

export const Router = () => {
    console.log('Router Auth ' + (getToken() !== '' ? 'yes ' : 'no ') + window.location.href);

    const unprotectedRoutes = useRoutes([
        { path: APP_PATH.AUTH, element: <Auth /> },
        { path: APP_PATH.BLANK, element: <Blank /> },
        { path: '*', element: <Navigate to={APP_PATH.BLANK} /> },
    ]);
    const next = getNext();
    const protectedRoutes = useRoutes([
        { path: APP_PATH.AUTH, element: <Navigate to={next != null ? next : APP_PATH.BLANK} /> },
        { path: APP_PATH.BLANK, element: <Blank /> },
        { path: APP_PATH.LLM_CATEGORISATION_INTERACTIONS, element: <LLMInteractionCategories /> },
        { path: '*', element: <Navigate to={next != null ? next : APP_PATH.BLANK} /> },
    ]);

    return getToken() !== '' ? protectedRoutes : unprotectedRoutes;
};

export default Router;
